import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=a5acddc0&scoped=true"
import script from "./addAddress.vue?vue&type=script&lang=js"
export * from "./addAddress.vue?vue&type=script&lang=js"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=a5acddc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5acddc0",
  null
  
)

export default component.exports